import { FormFieldContext } from "./form-field.context";
import type { FormFieldProps } from "./types-form-field";
import { useFormField } from "./use-form-field";
import { FormFieldView } from "./view-form-field";

export function FormFieldRoot({ children, ...options }: FormFieldProps) {
  const { context, ...viewModel } = useFormField(options);

  return (
    <FormFieldContext.Provider value={context}>
      <FormFieldView {...viewModel}>{children}</FormFieldView>
    </FormFieldContext.Provider>
  );
}
FormFieldRoot.displayName = "FormField.Root";
